export default {
  url: 'http://soushihe.test',
  imgUrl: 'https://ssh-prod-public.oss-cn-shenzhen.aliyuncs.com/'
}



// WEBPACK FOOTER //
// ./src/api/baseUrl.js